<div class="trigger-dialog r-content">
    <div class="dialog-close-btn" (click)="closeDialog()"></div>
    <div class="trigger-dialog-title">{{ 'designations' | translate }}</div>
    <div class="r-content-box">
	    <div class="r-header users_rolse_title">{{'sensors_menu' | translate}}</div>
	    <div class="row sensors-legend">
		    <div class="col-sm-4 legend-left">
	    		<span class="help-icon marker-active"></span>
	    		<span class="help-icon-text">{{'working_sensor' | translate}}</span>
	    	</div>
	    	<div class="col-sm-4">
	    		<span class="help-icon marker-active marker-selected"></span>
	    		<span class="help-icon-text">{{'selected_working_sensor' | translate}}</span>
	    	</div>
	    </div>
      <div class="row sensors-legend">
        <div class="col-sm-4 legend-left">
          <span class="help-icon marker-in-service-help"></span>
          <span class="help-icon-text">{{'sensor_in_service' | translate}}</span>
        </div>
        <div class="col-sm-4">
          <span class="help-icon marker-in-service marker-selected-in-service-help"></span>
          <span class="help-icon-text">{{'selected_in_service_sensor' | translate}}</span>
        </div>
      </div>
      <div class="row sensors-legend">
	    	<div class="col-sm-4 legend-left">
	    		<span class="help-icon marker-inactive"></span>
	    		<span class="help-icon-text">{{'idle_sensor' | translate}}</span>
	    	</div>
	    	<div class="col-sm-4">
	    		<span class="help-icon marker-inactive marker-selected"></span>
	    		<span class="help-icon-text">{{'selected_idle_sensor' | translate}}</span>
	    	</div>
	    	<div class="col-sm-4 help-icon-text warn">
	    		<p>{{'you_can_select' | translate}}</p>
	    		<p>{{'you_can_click' | translate}}</p>
	    	</div>
	    </div>

	    <div class="row sensors-legend">
		    <div class="col-sm-4 legend-left">
	    		<span class="help-icon marker-error"></span>
	    		<span class="help-icon-text">{{'error_sensor' | translate}}</span>
	    	</div>
	    	<div class="col-sm-4">
	    		<span class="help-icon marker-deleted"></span>
	    		<span class="help-icon-text">{{'deleted_sensor' | translate}}</span>
	    	</div>
	    </div>
	    <div class="r-header users_rolse_title top-border">{{'incidents_title' | translate}}</div>
	    <div class="row sensors-legend">
	    	<div class="legend-inc">
	    		<span class="help-icon inc-circle"></span>
	    		<span class="help-icon-text inc-circle-text">{{'incidents_critical' | translate}}</span>
	    	</div>
	    	<div class="legend-inc">
	    		<span class="help-icon inc-circle inc-orange"></span>
	    		<span class="help-icon-text inc-circle-text">{{'incidents_warning' | translate}}</span>
	    	</div>
	    	<div class="legend-inc">
	    		<span class="help-icon inc-circle inc-l-blue"></span>
	    		<span class="help-icon-text inc-circle-text">{{'incidents_info' | translate}}</span>
	    	</div>
	    	<div class="col-sm-4 help-icon-text warn warn-2">
	    		{{'system_draw_circle' | translate}}
	    	</div>
	    </div>
	    <div class="row sensors-legend">
	    </div>
    </div>
    <div class="buttons-right dialog-buttons">
	  <button mat-dialog-close>{{ 'ok' | translate }}</button>
    </div>
</div>
